import { IUntypedQuery, Topics } from '@zaplify/common';

export class GetProspectingPreviewDetailsQuery extends IUntypedQuery {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly userId: string, readonly userOrganizationId: string, readonly personId: string) {
        super();
    }
}
